import { createContext } from 'react';

export const fieldErrorsContext = createContext<string[]>([]);
